import addBillModalForm from "./add-bill-modal-form.json";
import addProduct from "./add-product.json";
import ballStatusIndicator from "./ball-status-indicator.json";
import basicComponents from "./components.json";
import coalaAddMenuModal from "./coala-add-menu-modal.json";
import coalaAddMenuProductModal from "./coala-add-menu-product-modal.json";
import coalaAddProductModal from "./coala-add-product-modal.json";
import coalaCategorizedProductsTable from "./coala-categorized-products-table.json";
import coalaMassEditModal from "./coala-mass-edit-modal.json";
import confirmModal from "./confirm-modal.json";
import consolidatedHistory from "./consolidated-history.json";
import containers from "./containers.json";
import dataTable from "./data-table.json";
import dialogs from "./dialogs.json";
import errorBoundary from "./error-boundary.json";
import eventTag from "./event-tag.json";
import formStatus from "./form-status.json";
import forms from "./forms.json";
import globalWarnings from "./global-warnings.json";
import header from "./header.json";
import helpers from "./helpers.json";
import hierarchicalChartAccountsSelector from "./hierarchical-chart-accounts-selector.json";
import inputFile from "./input-file.json";
import monthPicker from "./month-picker.json";
import notAvailable from "./not-available.json";
import notification from "./notification.json";
import notifications from "./notifications.json";
import openSalesReport from "./open-sales-report.json";
import paginator from "./paginator.json";
import pendingContracts from "./pending-contracts.json";
import periodDropdown from "./period-dropdown.json";
import pixKeyType from "./pix-key-type.json";
import pixTypeInput from "./pix-type-input.json";
import placeCheckbox from "./place-checkbox.json";
import placeFilter from "./place-filter.json";
import reportNavbar from "./report-navbar.json";
import reportPrintTemplate from "./report-print-template.json";
import reportTab from "./report-tab.json";
import reportTabs from "./report-tabs.json";
import selectImage from "./select-image.json";
import table from "./table.json";
import tableEmptyState from "./table-empty-state.json";
import tabsBackoffice from "./tabs-backoffice.json";
import transactionalHistory from "./transactional-history.json";
import withdrawsCards from "./withdraws-cards.json";
import xlsx from "./xlsx.json";
import { SYSTEM_PRODUCT_SELECT_ES_MX } from "#components/system-product-select/translations";
import { EXPORT_HISTORY_ES_MX } from "#components/export-history/translations";
import importXlsxDrawer from "./import-xlsx-drawer.json";
import dateRangeSelect from "./date-range-select.json";
import datahubChat from "./datahub-chat.json";
import { EXPORT_EMAIL_DRAWER_ES_MX } from "#components/export-email-drawer/translations";
import { EXPORT_BY_EMAIL_MODAL_ES_MX } from "#components/export-by-email-modal/translations";
import { PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_ES_MX } from "./payment-method-with-cashless-and-bonus";
import reconciliationTransactions from "./reconciliation-transactions.json";

export const components = {
	...basicComponents,
	tableEmptyState,
	periodDropdown,
	pixKeyType,
	addBillModalForm,
	addProduct,
	ballStatusIndicator,
	coalaAddMenuModal,
	coalaAddMenuProductModal,
	coalaAddProductModal,
	coalaCategorizedProductsTable,
	coalaMassEditModal,
	confirmModal,
	consolidatedHistory,
	containers,
	dataTable,
	dialogs,
	errorBoundary,
	formStatus,
	forms,
	globalWarnings,
	helpers,
	"hierarchical-chart-accounts-selector": hierarchicalChartAccountsSelector,
	monthPicker,
	notAvailable,
	notification,
	openSalesReport,
	paginator,
	placeCheckbox,
	pendingContracts,
	placeFilter,
	reportNavbar,
	reportTab,
	reportTabs,
	selectImage,
	table,
	tabsBackoffice,
	transactionalHistory,
	withdrawsCards,
	reportPrintTemplate,
	eventTag,
	inputFile,
	notifications,
	header,
	pixTypeInput,
	xlsx,
	importXlsxDrawer,
	datahubChat,
	bonusReportTotalizers: {
		receivedValue: "Valor total concedido",
		spentValue: "Productos pagados con bono",
		tipValue: "Servicio pagado con bono",
		spentInOtherEvent: "Ventas pagadas con bono en otro período",
		spentTipValueInOtherEvent: "Servicio pagado con bono en otro período",
		receivedValueTooltip: "Total de bonos concedidos en el período filtrado",
		spentValueTooltip: "Total de productos pagados con bono en el período filtrado",
		tipValueTooltip: "Total de servicios pagados con bono en el período filtrado",
		spentInOtherEventTooltip:
			"Total de bonos concedidos en el período filtrado y utilizados en un período diferente sin considerar servicio",
		spentTipValueInOtherEventTooltip:
			"Total de servicios pagados con bono concedido en el período filtrado y que fueron utilizados en un período diferente",
	},
	systemProductSelect: SYSTEM_PRODUCT_SELECT_ES_MX,
	exportHistory: EXPORT_HISTORY_ES_MX,
	exportEmailDrawer: EXPORT_EMAIL_DRAWER_ES_MX,
	paymentMethodWithCashlessAndBonusLabel: PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_ES_MX,
	dateRangeSelect,
	reconciliationTransactions,
	exportByEmailModal: EXPORT_BY_EMAIL_MODAL_ES_MX,
};
